import { render } from "./SiteNavbar.vue?vue&type=template&id=56d8ba80"
import script from "./SiteNavbar.vue?vue&type=script&lang=js"
export * from "./SiteNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__